import {View} from 'react-native';
import React from 'react';
import {Props} from './model';
import {useStyles} from '../../../../hooks/styles';

export default ({children, title, style, childStyle, titleStyle}: Props) => {
  const styles = useStyles(({isDesktop}) => ({
    title: {
      marginBottom: isDesktop ? 8 : 4,
    },
  }));
  return (
    <View style={style}>
      {title ? <View style={[styles.title, titleStyle]}>{title}</View> : null}
      <View style={childStyle}>{children}</View>
    </View>
  );
};
